import * as React from "react";
import { useLocation } from "react-router-dom";
import { HelpIconButton } from "../../../components-new/help/help-modal";

export default function Navbar({ toggleSidebar }) {
  const userDetails = localStorage.getItem("userDetail");
  const user = JSON.parse(userDetails);

  const path = useLocation().pathname;
  return (
    <nav className="bg-white px-6 py-3 border-b ">
      <div className="navbar flex flex-row items-center justify-between">
        {/* <img src={nogruntlogo} alt="Nogrunt" /> */}
        <img src={user.company?.brandLogo || "/logo.png"} alt="Nogrunt" />
        <HelpIconButton path={path} />
      </div>
    </nav>
  );
}
